import request from './services/axios.js'

export default {
  //首页展示最近三天的书刊以及查看书刊的接口（一个接口干两件事）
  homeType: (params) => {
    return request({
      params,
      url: '/ebook/getCases',
      method: 'get'
    })
  },
  cancelCollect: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadCollect/cancelCollect',
      method: 'post'
    })
  },
  collectWork: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadCollect/saveCollect',
      method: 'post'
    })
  },
  findOneCollect: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadCollect/findOneCollect',
      method: 'get'
    })
  },
  //查询用户是否订阅该作品
  findOneSubscribe: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/findOneSubscribe'
    })
  },
  orderRecByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribeRecord/findSubscribeRecordByPage',
      method: 'get'
    })
  },
  collectByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadCollect/findCollectByPage',
      method: 'get'
    })
  },
  orderByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/findSubscribeByPage',
      method: 'get'
    })
  },
  getChildSpaceSum: (params) => {
    return request({
      params,
      url: '/ebook/childAccount/getChildSpaceSum',
      method: 'get'
    })
  },
  getUserPageView: (params) => {
    return request({
      params,
      url: '/ebook/getUserPageView',
      method: 'get'
    })
  },
  getUserNetworkFlow: (params) => {
    return request({
      params,
      url: '/ebook/getUserNetworkFlow',
      method: 'get'
    })
  },
  addAttachPreview: (params) => {
    return request({
      params,
      url: '/ebook/accessRecord/addAttachPreview',
      method: 'get'
    })
  }
}
